<template>
  <div class="p-3 text-center">
    <div v-if="!confirming">
      <h3 class="text-[18px] font-bold text-grey-light-900">Cancellation Policy</h3>
      <hr class="my-4 w-[20%] justify-self-center" />
      <p class="text-[14px] text-grey-light-600 mt-1">
        Please note that cancellations and refunds are not handled by LayUp but are processed by the Merchant. For any
        queries, please contact the Merchant directly
      </p>
      <hr class="my-4" />
      <div class="mt-6 flex gap-3">
        <Button variant="outline" class="flex-1" @click="$emit('close')">Close</Button>
        <Button
          class="flex-1 bg-teal-600 hover:bg-teal-700"
          :disabled="isSubmitting"
          @click="suspendOnCancel ? $emit('accept') : (confirming = true)"
        >
          Accept
        </Button>
      </div>
    </div>
    <div v-else>
      <div class="w-14 h-14 rounded-full bg-amber-50 flex items-center justify-center mb-4 mx-auto">
        <AlertCircle class="w-7 h-7 text-red-600" />
      </div>
      <h3 class="text-[18px] font-bold text-grey-light-900 mb-2">Are you sure you want to cancel this order?</h3>
      <p class="text-[14px] text-grey-light-600 mb-6">
        By selecting 'YES' you acknowledge that this action cannot be reversed.
      </p>
      <div class="flex flex gap-3 w-full">
        <Button variant="outline" class="w-full" :disabled="isSubmitting" @click="confirming = false">No</Button>
        <Button class="w-full bg-teal-600 hover:bg-teal-700" :disabled="isSubmitting" @click="$emit('accept')">
          <Loader2 v-if="isSubmitting" class="h-4 w-4 animate-spin mr-2" />
          Yes
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { AlertCircle, Loader2 } from 'lucide-vue-next';
import { ref } from 'vue';

defineProps<{ isSubmitting: boolean; suspendOnCancel: boolean }>();

const confirming = ref(false);

defineEmits<{ close: []; accept: [] }>();
</script>
